import { render, staticRenderFns } from "./ViewPopup.vue?vue&type=template&id=6f8ad75f"
import script from "./ViewPopup.vue?vue&type=script&lang=js"
export * from "./ViewPopup.vue?vue&type=script&lang=js"
import style0 from "./ViewPopup.vue?vue&type=style&index=0&id=6f8ad75f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports